import Template from "../Template";

import StoreCard, { WarehouseCard } from "../../components/StoreCard";
import { useNavigate } from "react-router-dom";
import "../../styles/stores/mystores.css";
import CreateStore from "./CreateStore";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Plus } from "lucide-react";
import notSubImage from "../../assetsStatic/notSub.png";
import noStore from "../../assetsStatic/emptyStore.png";
import { setPage } from "../../slice/storeSlice";

let cloudinaryReduceOptimizeUrl = "https://res.cloudinary.com/demo/image/fetch/w_120,f_auto,q_auto/";
const Mystores = () => {
  const dispatch = useDispatch();
  const [openModal, setOpenModal] = useState(false);
  const navigate = useNavigate();

  const { user } = useSelector((state) => state.webStoreUser);
  const { employee } = useSelector((state) => state.employee);
  console.log(employee);

  useEffect(() => {
    if (Object.keys(user).length === 0 || user === null || user === undefined) {
      navigate("/sign-in");
    }
    dispatch(setPage(null));
  }, []);

  return (
    <>
      <Template>
        {/*         <h2>My Stores</h2>
        {user.userIsSubscribed ? (
          <>
            {!user.store.length ? (
              <div className='emptyStoreDiv'>
                <img src={require("../../assetsStatic/emptyStore.png")} />
                <h2 style={{ marginTop: "12px" }}>No store created</h2>
                <p style={{ textAlign: "center" }} className='descriptionPar12'>
                  You are yet to create a store. <br /> Click the button below to create a store.
                </p>
              </div>
            ) : (
              <div className='storeWrapper'>
                {user.store.map((store, index) => {
                  return (
                    <StoreCard
                      key={store._id}
                      storeCount={index}
                      maxStore={user.maxStore}
                      name={store.storeName}
                      address={store.storeAddress}
                      image={store.storeImage}
                      storeID={store._id}
                      rating={store.averageRating}
                      followers={store.numberOfFollowers}
                    />
                  );
                })}
              </div>
            )}

            {!user.warehouse.length ? (
              <div className='emptyStoreDiv2'></div>
            ) : (
              <>
                <h2>My Warehouse</h2>
                <div className='storeWrapper warehouseSmall'>
                  {user.warehouse.map((warehouse) => (
                    <StoreCard
                      name={warehouse.warehouseName}
                      address={warehouse.warehouseAddress}
                      onClick={() => navigate("/warehouse/warehouseID")}
                      image={warehouse.warehouseIcon}
                      warehouse={true}
                      storeID={warehouse._id}
                    />
                  ))}
                </div>
              </>
            )}

            <div className='buttonDivCretaeStore'>
              <div>
                <button onClick={() => setOpenModal(true)}>
                  <BsPlusLg />
                </button>
                <div>create store or warehouse</div>
              </div>
            </div>
          </>
        ) : (
          <div className='userNotSubscribeddiv23'>
            <div>
              <img style={{ marginBottom: "12px" }} src={require("../../assetsStatic/notSub.png")} />
              <h2>You are not subscribed YET 😒</h2>
              <p className='descriptionPar12'>
                You need to subscribe to create and manage your stores. Don't worry <br /> We have cheap packages for every busines type <br /> Select a package
                that suits you.{" "}
              </p>
              <button onClick={() => navigate("/settings/subscription")}>Subscribe Now</button>
            </div>
          </div>
        )} */}
        {user.userIsSubscribed ? (
          <>
            <div className='store-management-container-unique'>
              {!user.store.length ? (
                <div className='emptyStoreDiv'>
                  <img src={noStore} />
                  <h2 style={{ marginTop: "12px" }}>No store created</h2>
                  <p style={{ textAlign: "center" }} className='descriptionPar12'>
                    You are yet to create a store. <br /> Click the button below to create a store.
                  </p>
                </div>
              ) : (
                <>
                  <section>
                    <h1 className='section-header-unique-store'>My Stores</h1>
                    {/* <div className='stores-horizontal-grid-unique'>
                      {user.store.map((store, index) => {
                        if (employee && employee.employeeAccessLevel === "admin") {
                          // Admin can see all stores
                          return (
                            <StoreCard
                              key={store._id}
                              storeCount={index}
                              maxStore={user.maxStore}
                              name={store.storeName}
                              address={store.storeAddress}
                              image={store.storeImage}
                              storeID={store._id}
                              rating={store.averageRating}
                              followers={store.numberOfFollowers}
                            />
                          );
                        }

                        // Non-admin employees can only see their assigned store
                        if (employee && String(employee.storeAssigned.storeID) === String(store._id)) {
                          return (
                            <StoreCard
                              key={store._id}
                              storeCount={index}
                              maxStore={user.maxStore}
                              name={store.storeName}
                              address={store.storeAddress}
                              image={store.storeImage}
                              storeID={store._id}
                              rating={store.averageRating}
                              followers={store.numberOfFollowers}
                            />
                          );
                        }
                      })}
                    </div> */}
                    <div className='stores-horizontal-grid-unique'>
                      {user.store
                        .filter((store) => {
                          // Admin can access all stores
                          if (employee?.employeeAccessLevel === "admin") {
                            return true;
                          }

                          // Other employees can only access their assigned store
                          return employee?.storeAssigned?.storeID && String(employee.storeAssigned.storeID) === String(store._id);
                        })
                        .map((store, index) => (
                          <StoreCard
                            key={store._id}
                            storeCount={index}
                            maxStore={user.maxStore}
                            name={store.storeName}
                            address={store.storeAddress}
                            image={store.storeImage}
                            storeID={store._id}
                            rating={store.averageRating}
                            followers={store.numberOfFollowers}
                          />
                        ))}
                    </div>
                  </section>

                  {!user.warehouse.length ? (
                    <div className='emptyStoreDiv2'></div>
                  ) : (
                    <section>
                      <h1 className='section-header-unique-store'>My Warehouse</h1>
                      <div className='warehouse-horizontal-grid-unique'>
                        {user.warehouse.map((warehouse, index) => (
                          <WarehouseCard
                            key={index}
                            name={warehouse.warehouseName}
                            address={warehouse.warehouseAddress}
                            image={warehouse.warehouseIcon}
                            warehouse={true}
                            warehouseID={warehouse._id}
                          />
                        ))}
                      </div>
                    </section>
                  )}
                </>
              )}

              {/* Add Button */}
              {employee && employee.employeeAccessLevel === "admin" && (
                <button onClick={() => setOpenModal(true)} className='add-button-unique-floating' aria-label='Add new store or warehouse'>
                  <Plus />
                </button>
              )}
            </div>
          </>
        ) : (
          <div className='userNotSubscribeddiv23'>
            <div>
              <img style={{ marginBottom: "12px" }} src={notSubImage} />
              <h2>You are not subscribed YET 😒</h2>
              <p className='descriptionPar12'>
                You need to subscribe to create and manage your stores. Don't worry <br /> We have cheap packages for every busines type <br /> contact your
                boss.{" "}
              </p>
              <button disabled>Subscribe Now</button>
            </div>
          </div>
        )}
      </Template>
      {openModal && <CreateStore closeModal={setOpenModal} />}
    </>
  );
};

export default Mystores;
